import Moment from 'moment';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import { Link , NavLink, Outlet  } from "react-router-dom";
import axios from "axios";
import { Bars } from 'react-loader-spinner'

export const changeDateFotmate = (date='' , format='') => 
{
  return Moment(date).format(format);
}
export const currencySymbol = () =>   'XOF ';

export const filebasepath = () =>   'https://projects.softechplanet.com/ivoire/uploads/';
export const apibaseURl = 'https://projects.softechplanet.com/ivoire/api/';
  
export const loggedInUserDetails = (key='') => 
{
    let getuserloggedIn = JSON.parse(localStorage.getItem("admin"));
    if(getuserloggedIn)
    {
      if(getuserloggedIn.user[key] != undefined && getuserloggedIn.user[key] != '')
      {
        return getuserloggedIn.user[key];
      }
    }
    return false;
};

export const loggedInCustomerDetails = (key='') => 
{
    let getuserloggedIn = JSON.parse(localStorage.getItem("customer"));
    if(getuserloggedIn)
    {
      if(getuserloggedIn.user[key] != undefined && getuserloggedIn.user[key] != '')
      {
        return getuserloggedIn.user[key];
      }
    }
    return false;
};

export const updateSession = (key='' , value="") => 
{
    let getuserloggedIn = JSON.parse(localStorage.getItem("customer"));

    if(getuserloggedIn)
    {
      getuserloggedIn['user'][key] = value;
      localStorage.setItem('customer', JSON.stringify(getuserloggedIn));
    }
    return false;
};

export const  apiCallpost = async (url , data) => 
{
    let res = await fetch(apibaseURl+url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    return res;

};

export const  alertDanger =  (message) => 
{
     return (
      <div className="alert ivo-alert-text alert-danger" role="alert">
      <div className="alert-container align-items-center vertical-align">
        <div className="alertbox-1">
          <i className="fa fa-exclamation-triangle "></i>
        </div>
        <div className="alertbox-2">
          <div className="ivo-alert-content">
            <strong>Alert:</strong> {message}

          </div>
        </div>
      </div>
      </div>
     );

};

export const  customalert =  (message ,  type='warning' ,  link='') => 
{
    let icon = '';
    let text = '';
    let customclassName = ''
    if(type == 'warning')
    {
      icon = 'fa fa-exclamation-triangle';
      text = 'Alert:';
      customclassName = 'alert-warning';
    }else if (type == 'success')
    {
      icon = 'fa-solid fa-circle-check';
      text = 'Success:';
      customclassName = 'alert-success';   
    }
    else if (type == 'info')
    {
      icon = 'fa-solid fa-circle-info';
      text = 'Information:';
      customclassName = 'alert-info';   
    }else
    {
      icon = 'fa fa-exclamation-triangle';
      text = 'Alert:';
      customclassName = 'alert-danger';   
    }
     return (
      <div className = {'alert ivo-alert-text '+ customclassName}  role="alert">
      <div className="alert-container align-items-center vertical-align">
        <div className="alertbox-1">
          <i className={icon}></i>
        </div>
        <div className="alertbox-2">
          <div className="ivo-alert-content">
            <strong>{text}</strong> {message}  
              {link && 
                <Link to={`${link}`} className='alertLink'>Click Here</Link>
              }

          </div>
        </div>
      </div>
      </div>
     );

};

export const  alertSuccess =  (message) => 
{
     return (
      <div className="alert ivo-alert-text alert-success" role="alert">
      <div className="alert-container align-items-center vertical-align">
        <div className="alertbox-1">
        <i className="fa-solid fa-circle-check"></i>
        </div>
        <div className="alertbox-2">
          <div className="ivo-alert-content">
            <strong>Success:</strong> {message}

          </div>
        </div>
      </div>
      </div>
     );

};

export const errorToast = (text , positions='top-right' ,autoClose = '3000' ) => {
  
  if(positions != '')
  {
    positions = positions;
  }
  toast.error(text,
    {
      autoClose: autoClose,
      position: positions,
      transition: Zoom,
      theme: "colored",
      closeOnClick: true,
      pauseOnHover: true,
    }
  );
};

export const successToast = (text , positions='top-right' ,autoClose = '3000' , hideProgressBar=false) => {
  
  if(positions != '')
  {
    positions = positions;
  }
  toast.success(text,
    {
      autoClose: autoClose,
      position: positions,
      transition: Zoom,
      theme: "colored",
      closeOnClick: true,
      pauseOnHover: true,
      hideProgressBar: hideProgressBar,
    }
  );
};

export const warningToast = (text , positions='top-right' ,autoClose = '3000' , hideProgressBar=false) => {
  
  if(positions != '')
  {
    positions = positions;
  }
  toast.warning(text,
    {
      autoClose: autoClose,
      position: positions,
      transition: Zoom,
      theme: "colored",
      closeOnClick: true,
      pauseOnHover: true,
      hideProgressBar: hideProgressBar,
    }
  );
};

export const loaderBar = (Boxheight='300' , height='50' ) =>
{
 return (
  <div className='loaderapp-container' style={{"height" : Boxheight+"px"}}>
  <Bars
    height={height}
    width={height}
    color="#2d475b"
    ariaLabel="bars-loading"
    wrapperStyle={{}}
    wrapperClass="text-center loaderapp"
    visible={true}
  />
  </div>
 )
};


export  const getUser = async () => {
  var test = {}; 
  var data = {
      'id':loggedInCustomerDetails('id')
  }
 
    await  axios({
      method: "post",
      url: apibaseURl+"user/"+loggedInCustomerDetails('id'),
      data: data,
      headers: { "Content-Type": "application/json" },
    }).then(function (response) {
        //handle success
          //console.log(response);
        test =  response.data;
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });

      return test;
  };

  export  const toplevelAlerts =  (customer) => {

      return (
          <>  
                { Object. keys(customer). length > 0 &&  
                    <> 
                  {  customer?.selfi_info?.status != '' ?
                      <>
                          {customer?.selfi_info?.status == 'uploaded' &&
                                <div className="mt-3">
                                      {customalert('Selfie for KYC has been uploaded successfully, it will be approved after verification.' , 'info')}
                              </div>
                          }

                          {customer?.selfi_info?.status == 'rejected' &&
                                <div className="mt-3">
                                      {customalert('Selfie uploaded for KYC has been rejected after verification, upload it again.' , 'info')}
                              </div>
                          }

                      </>
                        
                  : 
                    <div className="mt-3">
                          {customalert('Your KYC is pending please complete it' , 'warning' , '/home/my-account/kyc')}
                    </div>
                  }
                  {customer.is_approved == '0'  &&                          
                      <div className="  mt-3">
                          {customalert('Your account is not yet approved Your account will be verified and approved.' , 'warning')}
                      </div> 
                  }
                   </>
                }

          </>

      );
      
    };


  // export const getUser = async () => {
  //       return {'test':150 , 'fdsfgd':14141}
  //   };








   